import { on, select, setStyle } from 'modules/dom'

const IFRAME_SELECTOR = '.js-iframe'

export default el => {
  const iframeEl = select(IFRAME_SELECTOR, el)
  on('message', (e) => {
    setStyle('height', `${e.data.height}px`, iframeEl)
    setStyle('opacity', 1, iframeEl)
  }, window)
}
